/**
 * Mapping between German (default) and English route paths.
 * German paths are used without prefix, English paths under /en.
 */
const ROUTE_MAP: Array<[string, string]> = [
  ['/ki-agenten', '/ai-agents'],
  ['/use-cases', '/use-cases'],
  ['/sicherheit', '/security'],
  ['/integrationen', '/integrations'],
  ['/integrationen/amazon-sp-api', '/integrations/amazon-sp-api'],
  ['/integrationen/mirakl', '/integrations/mirakl'],
  ['/integrationen/woocommerce', '/integrations/woocommerce'],
  ['/integrationen/shopware', '/integrations/shopware'],
  ['/pricing', '/pricing'],
  ['/ueber-uns', '/about-us'],
  ['/kontakt', '/contact'],
  ['/impressum', '/imprint'],
  ['/datenschutz', '/privacy'],
  ['/danke', '/thank-you'],
  ['/blog', '/blog'],
];

/** Convert a German path to its English equivalent */
export function dePathToEn(dePath: string): string {
  // Try longest match first (e.g. /integrationen/amazon-sp-api before /integrationen)
  for (const [de, en] of [...ROUTE_MAP].sort((a, b) => b[0].length - a[0].length)) {
    if (dePath === de) return en;
    if (dePath.startsWith(`${de}/`)) return en + dePath.slice(de.length);
  }
  return dePath;
}

/** Convert an English path to its German equivalent */
export function enPathToDe(enPath: string): string {
  for (const [de, en] of [...ROUTE_MAP].sort((a, b) => b[1].length - a[1].length)) {
    if (enPath === en) return de;
    if (enPath.startsWith(`${en}/`)) return de + enPath.slice(en.length);
  }
  return enPath;
}

/** All English route paths (for registering in the router) */
export const EN_ROUTES = ROUTE_MAP.map(([, en]) => en);

/** All German route paths */
export const DE_ROUTES = ROUTE_MAP.map(([de]) => de);

/**
 * Redirects that follow FROM the map — do not hand-list them in App.tsx.
 *
 * The old hand-written list drifted: `/en/impressum` and `/en/datenschutz` were
 * registered as duplicate PAGES instead of redirects (same English content at two
 * URLs), and `/en/danke` was missing entirely. Deriving them makes that class of
 * omission impossible: a pair added to ROUTE_MAP brings its redirect along.
 */

/** `/en/<german-slug>` → `/en/<english-slug>`, for pairs whose slugs differ. */
export const EN_ALIAS_REDIRECTS: Array<{ from: string; to: string }> = ROUTE_MAP.filter(
  ([de, en]) => de !== en,
).map(([de, en]) => ({ from: `/en${de}`, to: `/en${en}` }));

/** Unprefixed legacy path → its `/de` equivalent. */
export const DE_LEGACY_REDIRECTS: Array<{ from: string; to: string }> = ROUTE_MAP.map(([de]) => ({
  from: de,
  to: `/de${de}`,
}));
